// src/data/gyms/NorthStar.js
export const NorthStar = {
  id: "northstar",
  name: "North Star Athletics",
  color: "#0EA5E9", // Cool Blue
  lightColor: "#E0F2FE",
  logo: "🌟",

  teams: [
    { id: "shiv3r", name: "Shiv3r", level: "L3 Senior - D2" },
    { id: "icequeens", name: "Ice Queens", level: "L1 Junior - Flex - D2" },
    { id: "legicy", name: "LegICY", level: "L1 Youth - Flex - D2" },
    { id: "frozenreign", name: "Frozen Reign", level: "L1 Senior - D2" },
    { id: "arcticstorm", name: "Arctic Storm", level: "L2 Junior - Flex - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "1:23 PM",
      teamId: "shiv3r",
      meet: "12:47 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "2:19 PM",
      teamId: "icequeens",
      meet: "1:43 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:12 PM",
      teamId: "legicy",
      meet: "2:36 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "3:30 PM",
      teamId: "frozenreign",
      meet: "2:54 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:29 PM",
      teamId: "arcticstorm",
      meet: "3:53 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // Shiv3r (Row 169) [cite: 30]
    {
      day: "Sunday",
      time: "10:38 AM",
      teamId: "shiv3r",
      meet: "10:02 AM",
      panel: "Hall A",
    },

    // Ice Queens (Row 186)
    {
      day: "Sunday",
      time: "12:00 PM",
      teamId: "icequeens",
      meet: "11:24 AM",
      panel: "Hall A",
    },

    // LegICY (Row 196) - Found in PDF!
    {
      day: "Sunday",
      time: "12:39 PM",
      teamId: "legicy",
      meet: "12:03 PM",
      panel: "Hall B",
    },

    // Frozen Reign (Row 206) - Found in PDF!
    {
      day: "Sunday",
      time: "2:03 PM",
      teamId: "frozenreign",
      meet: "1:27 PM",
      panel: "Hall A",
    },

    // Arctic Storm (Row 220) [cite: 43]
    {
      day: "Sunday",
      time: "2:56 PM",
      teamId: "arcticstorm",
      meet: "2:20 PM",
      panel: "Hall B",
    },
  ],
};
